import { defineStore } from 'pinia'
import * as sdk from '@/helpers/sdk'

import useCache from '@/composables/useCache'

export const groupsKey = 'groupsData'
export const groupsStatusKey = 'groupsStatus'

const useSettingsStore = defineStore('settings', () => {
  const { get: getGroups, data: groupsData, status: groupsStatus } = useCache(async () => {
    const result = await sdk.v2.settings.get({
      url: { settingName: 'groups' },
    })
    return result.data.data
  })

  return {
    getGroups,
    groupsData,
    groupsStatus,
  }
})

export default useSettingsStore
